var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2725 13.1251L32.0772 0.383475C32.0468 0.346105 32.0086 0.315919 31.9652 0.29508C31.9218 0.274241 31.8743 0.263265 31.8261 0.262939H11.1743C11.0789 0.262939 10.9835 0.30814 10.9232 0.383475L0.727891 13.1251C0.680687 13.1849 0.655853 13.2592 0.657688 13.3353C0.659522 13.4115 0.687908 13.4846 0.737935 13.542L21.2591 36.6195C21.3194 36.6898 21.4098 36.725 21.5002 36.725C21.5906 36.725 21.676 36.6848 21.7413 36.6195L42.2625 13.542C42.3125 13.4846 42.3409 13.4115 42.3427 13.3353C42.3446 13.2592 42.3197 13.1849 42.2725 13.1251ZM28.1899 3.14575L29.9176 9.87064L23.263 3.14575H28.1899ZM28.6018 12.1106H14.3987L21.5002 4.9337L28.6018 12.1106ZM14.8105 3.14575H19.7374L13.0778 9.87064L14.8105 3.14575ZM12.1286 3.49731L9.91372 12.1106H5.23794L12.1286 3.49731ZM5.55936 14.6218H10.3004L16.6185 27.062L5.55936 14.6218ZM21.5002 31.1201L13.118 14.6218H29.8774L21.5002 31.1201ZM26.3769 27.062L32.7 14.6218H37.4411L26.3769 27.062ZM33.0867 12.1106L30.8719 3.49731L37.7625 12.1106H33.0867Z",
    fill: "#5CBF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizedIcon);
export default __webpack_public_path__ + "static/media/customized-icon.fb1f16da82de9d8315f8fbfce37a209b.svg";
export { ForwardRef as ReactComponent };